<template>
    <select ref="dropdown" class="form-control new-design" @input="handleChange">
        <option v-if="placeholder" disabled :selected="!selected && !hasDefault"> {{ placeholder }}</option>
        <option v-for="(option,index) of options" :value="option.property_field_value_id"
                :key="index" :selected="option.property_field_value_id == selected || option.is_default">
            {{ option.value }}
        </option>
    </select>
</template>

<script>
export default {
    name: "SelectList",
    props: ['value', 'options', 'selected', 'placeholder'],
    computed:{
      hasDefault(){
          for (let option of this.options){
              if(option.is_default)
                  return true
          }
          return false
      }
    },
    methods: {
        handleChange(event) {
            this.$emit('input', event.target.value)
        }
    },
    mounted() {
        if (this.selected)
            this.$emit('input', this.selected)
    }
}
</script>

<style scoped>

.form-control.new-design:invalid {
    color: #979FA8;
}

.form-control.new-design::placeholder {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}

.form-control.new-design {
    padding-left: 16px;
    border: 1px solid #E0E2E5;
    border-radius: 8px;
    box-sizing: border-box;

    height: 65px;

    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}
</style>